import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=06f782c1&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=ts"
export * from "./Setting.vue?vue&type=script&lang=ts"
import style0 from "./Setting.vue?vue&type=style&index=0&id=06f782c1&lang=scss&scoped=true"
import style1 from "./Setting.vue?vue&type=style&index=1&id=06f782c1&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f782c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f782c1')) {
      api.createRecord('06f782c1', component.options)
    } else {
      api.reload('06f782c1', component.options)
    }
    module.hot.accept("./Setting.vue?vue&type=template&id=06f782c1&scoped=true", function () {
      api.rerender('06f782c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contents/setting/components/Setting.vue"
export default component.exports